import { SUPPORTED_LOCALES } from '@/common/constants';

export const locales = SUPPORTED_LOCALES;
export type Locale = (typeof locales)[number];
